import React, { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { ReactComponent as WarningIcon } from '../../../assets/icons/user-plan/warning.svg';
import { useStyles } from './WarningNoticeBanner.styles';

interface IWarningNoticeBannerProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function WarningNoticeBanner(props: IWarningNoticeBannerProps) {
  const { title, children, className } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <Box className={clsx(classes.root, className)} role="status">
      <WarningIcon className={classes.icon} aria-hidden />
      <Box className={classes.text}>
        <Typography
          variant="subtitle1"
          component="h2"
          className={classes.title}>
          {title}
        </Typography>
        <Typography
          variant="text-md"
          component="div"
          className={classes.description}>
          {children}
        </Typography>
      </Box>
    </Box>
  );
}
